<template>
  <div id="driver_edit" class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-5 col-xs-12">
        <div class="title_left">
          <h3>司機詳細資料</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row col-md-8">
      <form class="" name="payment">
        <div class="col-md-12">
          <div class="driverTitle">
            <h4>車隊資料</h4>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12" for="">
                呼號/隊編
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  :disabled="!edit_info"
                  v-model="driver.info.call_number"
                  id="inputSuccess2"
                  placeholder="隊編必填"
                  type="text"
                  required=""
                  class="form-control col-md-7 col-xs-12"
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label
                class="control-label col-md-2 col-sm-2 col-xs-12"
                for="first-name"
              >
                計程車種類
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <select
                  @change="onDriverTypeChange(driver.info.type)"
                  :disabled="!edit_info"
                  v-model="driver.info.type"
                  id="heard"
                  class="form-control"
                  required=""
                >
                  <option :value="0">一般計程車</option>
                  <option :value="1">多元計程車</option>
                </select>
              </div>
            </div>
          </div>
          <div
            class="stored"
            v-if="teamCodeCookie === 111 || teamCodeCookie === 123"
          >
            <h3 class="stored-title">儲值扣款設定</h3>
            <form class="form-inline margin10">
              <div class="form-group mx-sm-3 mb-2">
                <label for="fareOfPercent">車資</label>
                <input
                  type="number"
                  min="1"
                  class="form-control"
                  id="fareOfPercent"
                  v-model="stored.fareOfPercent"
                />
                <span>％ +</span>
              </div>
              <div class="form-group mx-sm-3 mb-2">
                <label for="platformFee">平台費 $</label>
                <input
                  type="number"
                  min="1"
                  class="form-control"
                  id="platformFee"
                  v-model="stored.platformFee"
                />
                ，
              </div>
              <div class="form-group mx-sm-3 mb-2">
                <label for="stored_value" style="display: inline">
                  儲值金額低於
                </label>
                <div
                  data-tip="司機儲值餘額低於此設定，會將司機設定為停權。"
                  style="display: inline"
                >
                  <input
                    type="number"
                    min="1"
                    class="form-control"
                    id="stored_value"
                    v-model="stored.thresholdValue"
                  />
                </div>
                <span>元，則無法接單。</span>
              </div>
              <button class="btn btn-primary" @click.prevent="storedSave">
                設定儲存
              </button>
            </form>
            <span>儲值餘額</span>
            <span>{{ this.stored.totalAmount }} 元</span>
            <a
              href="#"
              data-toggle="modal"
              data-target="#myModal"
              @click.prevent="openStoredModal(1, status)"
            >
              查看儲值紀錄
            </a>
            <DriverStoredModal
              :data="driverStored"
              :paging="driverStoredPaging"
              @changerecord="openStoredModal"
            ></DriverStoredModal>
          </div>
          <div class="driverTitle">
            <h4>司機基本資料</h4>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label
                class="control-label col-md-2 col-sm-2 col-xs-12"
                for="first-name"
              >
                司機姓名
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  :disabled="!edit_info"
                  v-model="driver.info.name"
                  type="text"
                  class="form-control"
                  id="inputSuccess4"
                  placeholder="司機姓名必填"
                  required=""
                />
              </div>
              <label
                class="control-label col-md-2 col-sm-2 col-xs-12"
                for="first-name"
              >
                司機性別
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <select
                  :disabled="!edit_info"
                  v-model="driver.info.gender"
                  class="form-control"
                  required=""
                >
                  <option value="0">男</option>
                  <option value="1">女</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label
                class="control-label col-md-2 col-sm-2 col-xs-12"
                for="first-name"
              >
                電話號碼/帳號
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  :disabled="!edit_info"
                  v-model="driver.info.account"
                  type="text"
                  class="form-control"
                  placeholder="電話必填"
                  required=""
                />
              </div>
              <label
                class="control-label col-md-2 col-sm-2 col-xs-12"
                for="first-name"
              >
                密碼
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  :disabled="!edit_info"
                  v-model="driver.info.password"
                  type="password"
                  class="form-control"
                  placeholder="司機密碼必填"
                  required=""
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label
                class="control-label col-md-2 col-sm-2 col-xs-12"
                for="first-name"
              >
                聯絡電話1
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  :disabled="!edit_info"
                  v-model="driver.info.contact1"
                  type="text"
                  class="form-control"
                  placeholder="聯絡電話1"
                  data-contact1
                />
              </div>
              <label
                class="control-label col-md-2 col-sm-2 col-xs-12"
                for="first-name"
              >
                聯絡電話2
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  :disabled="!edit_info"
                  v-model="driver.info.contact2"
                  type="text"
                  class="form-control"
                  placeholder="聯絡電話2"
                  data-contact2
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                電子信箱
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  :disabled="!edit_info"
                  v-model="driver.info.email"
                  type="text"
                  class="form-control"
                  placeholder=""
                />
              </div>
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                身份字號
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  :disabled="!edit_info"
                  v-model="driver.info.identify"
                  type="text"
                  class="form-control col-md-6"
                  placeholder="身分字號必填"
                  required=""
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                生日
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  :disabled="!edit_info"
                  v-model="driver.info.birthday"
                  type="date"
                  class="form-control"
                  placeholder="生日"
                  data-email
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                戶籍地址
                <span>*</span>
              </label>
              <div class="col-md-6 col-sm-6 col-xs-12">
                <input
                  :disabled="!edit_info"
                  v-model="driver.info.resident_address"
                  type="text"
                  class="form-control"
                  placeholder="戶籍地址必填"
                  required=""
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                通訊地址
                <span>*</span>
              </label>
              <div class="col-md-6 col-sm-6 col-xs-12">
                <input
                  :disabled="!edit_info"
                  v-model="driver.info.address"
                  type="text"
                  class="form-control"
                  placeholder="通訊地址"
                />
              </div>
            </div>
          </div>
          <div class="driverTitle">
            <h4>車輛資訊</h4>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                營業執照
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  :disabled="!edit_info"
                  v-model="driver.info.business_license"
                  type="text"
                  class="form-control col-md-6"
                  placeholder="營業執照"
                />
              </div>
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                製造車廠必填
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  :disabled="!edit_info"
                  v-model="driver.info.car_brand"
                  type="text"
                  class="form-control"
                  placeholder="製造車廠必填"
                  required=""
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                車牌必填
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  :disabled="!edit_info"
                  v-model="driver.info.licence"
                  type="text"
                  class="form-control"
                  placeholder="車牌必填"
                  required=""
                />
              </div>
            </div>
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                可載座位數
                <span>*</span>
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  :disabled="!edit_info"
                  v-model="driver.info.available_seat"
                  type="text"
                  class="form-control"
                  placeholder="可載座位數"
                  required=""
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                領牌日
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.info.receive_car_license_date"
                  :disabled="!edit_info"
                  type="date"
                  class="form-control"
                  placeholder="領牌日"
                  data-email
                />
              </div>
            </div>
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                出廠日
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.info.car_leave_factory_date"
                  :disabled="!edit_info"
                  type="date"
                  class="form-control"
                  placeholder="出廠日期"
                  data-email
                  @change="
                    onCarLeaveFactoryDateChange(
                      driver.info.car_leave_factory_date,
                    )
                  "
                />
              </div>
            </div>
          </div>
          <div class="row margin10">
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                職業駕照發照日
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.info.professional_driver_license_date"
                  :disabled="!edit_info"
                  type="date"
                  class="form-control"
                  placeholder="職業駕照發照日"
                  data-email
                />
              </div>
            </div>
            <div class="form-group">
              <label class="control-label col-md-2 col-sm-2 col-xs-12">
                裝錶日
              </label>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <input
                  v-model="driver.info.install_taxi_meter_date"
                  :disabled="!edit_info"
                  type="date"
                  class="form-control"
                  placeholder="裝錶日"
                  data-email
                />
              </div>
            </div>
          </div>
          <!-- <div class="row margin10">
            <div class="form-group">
                <label class="control-label col-md-2 col-sm-2 col-xs-12">製造西元年份 <span>*</span></label>
                <div class="col-md-4 col-sm-4 col-xs-12">
                     <input @change="onCarYearChange(driver.info.car_year)" :disabled='!edit_info' v-model="driver.info.car_year" type="number" min="1900" :max="car_year_max" class="form-control"  placeholder="製造西元年份 e.g. 2017必填" required="">
                </div>
            </div>
        </div> -->
          <div class="driverTitle">
            <h4>服務項目</h4>
          </div>
          <div class="row">
            <div class="col-md-12 col-md-12">
              <driver-service-checkbox
                ref="driverServiceList"
                :type="type"
                :edit_info="!edit_info"
              ></driver-service-checkbox>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-md-4 col-xs-12">
      <div class="x_panel">
        <div class="x_title">
          <h4>權限狀態</h4>
          <div class="clearfix"></div>
        </div>
        <div class="row" v-show="startSuspenionTime !== null">
          <div class="col-md-12">
            <h2 class="suspension-time">
              停權時間: {{ startSuspenionTime }}~{{ endSuspenionTime }}
            </h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <select
              v-model="driver.info.authorize"
              :disabled="!edit_info"
              class="form-control"
              required=""
              @change="changeAuthorize"
            >
              <option value="0">正常授權</option>
              <option value="1">停權</option>
              <option value="2">審核中</option>
            </select>
          </div>
          <div class="col-md-3">
            <button
              class="btn btn-danger"
              :disabled="driver.info.authorize !== '1' || !edit_info"
              @click="showSetSuspensionTime()"
            >
              設定停權時間
            </button>
          </div>
        </div>
        <el-input
          v-model="suspensionReason"
          v-show="driver.info.authorize === '1'"
          placeholder="請輸入停權原因"
          style="margin: 1rem 0"
        />
        <div class="row">
          <div class="col-md-12">
            <p>*正式授權後將會開啟司機使用手機接單的權限</p>
            <p>*停權後將會關閉司機使用手機接單的權限</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-xs-12">
      <div class="x_panel">
        <div class="x_title">
          <h4>APP方案選擇</h4>
          <div class="clearfix"></div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <select
              v-model="driver.info.plan"
              :disabled="!edit_info"
              class="form-control"
              required=""
            >
              <option value="0">車隊叫車/APP/Line</option>
              <option value="1">APP/Line</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <p>*車隊叫車包含：商家叫車與電話叫車</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-xs-12">
      <div class="x_panel">
        <div class="x_title">
          <h4>填寫車隊客服備註-最多50字元</h4>
          <div class="clearfix"></div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <textarea
              :disabled="!edit_info"
              v-model="driver.info.team_company_note"
              cols="50"
              rows="3"
              class="col-md-10 form-control textareastyle"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-xs-12">
      <div class="x_panel">
        <div class="x_title">
          <h4>填寫司機備註(乘客看得到)-最多50字元</h4>
          <div class="clearfix"></div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <textarea
              :disabled="!edit_info"
              v-model="driver.info.note"
              cols="50"
              rows="3"
              class="col-md-10 form-control textareastyle"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-xs-12">
      <div class="x_panel">
        <div class="row">
          <div class="col-md-12" v-if="permisionEditDriver">
            <button
              @click="onEditDriverBtnClick"
              type="button"
              v-if="!edit_info"
              class="mybtnstyle btn-dark col-md-3"
            >
              編輯資料
            </button>
            <button
              :disabled="!edit_info"
              @click="onUpdateDriverBtnClick"
              class="mybtnstyle btn-dark col-md-3"
              v-else
            >
              送出
            </button>
            <button
              @click="onDeleteDriverBtnClick"
              type="button"
              class="mybtnstyle btn-danger col-md-3"
            >
              刪除
            </button>
          </div>
        </div>
      </div>
    </div>
    <SetSuspensionTime
      ref="setSupspensionTime"
      @getDate="getSuspensionDate"
    ></SetSuspensionTime>
  </div>
</template>

<script>
import API from '../../assets/js/libs/API'
import dayjs from 'dayjs'
import { cookies } from '@/utils/cookies'
import { Notification } from 'element-ui'
import moment from 'moment'
import AddPaymentItem from './AddPaymentItem.vue'
import PaymentItem from './PaymentItem.vue'
import DriverServiceCheckbox from '../../components/driver/DriverServiceCheckBox_1'
import SetSuspensionTime from '../../components/driver/SetSuspensionTime'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'
import Driver from '../../assets/js/libs/Driver'
import DriverStoredModal from '@/components/driver/DriverStoredModal'
import { checkObjectParameterDiffToValue } from '../../assets/js/tool/checkObjectUtils'
import { getAdminAuthorization } from '../../assets/js/tool/adminAuth'

let driver = new Driver()
export default {
  name: 'DriverDetail',
  components: {
    AddPaymentItem,
    PaymentItem,
    DriverServiceCheckbox,
    SetSuspensionTime,
    DriverStoredModal,
  },
  data() {
    return {
      teamCodeCookie: cookies.get('GladTeamCode'),
      stored: {
        fareOfPercent: 0,
        platformFee: 0,
        thresholdValue: 0,
        totalAmount: 0,
      },
      status: '儲值紀錄',
      driverStored: [],
      driverStoredPaging: {},
      deductData: [],
      deductPaging: [],
      id: this.$route.params.id,
      driver: {
        info: {},
        service: [],
      },
      bills: [],
      suspension: null,
      car_year_max: moment().year(),
      edit_info: false,
      type: 0,
      startSuspenionTime: null,
      endSuspenionTime: null,
      driverHistory: null,
      suspensionReason: null,
      driverInfo: {
        account: '帳號',
        address: '地址',
        authorize: '權限',
        available_seat: '可載人數',
        birthday: '生日',
        business_license: '車牌',
        call_number: '呼號',
        car_brand: '車品牌',
        car_leave_factory_date: '出廠日',
        car_year: '年份',
        change_password_date: '',
        change_password_fequency: '',
        contact1: '聯絡電話1',
        contact2: '聯絡電話2',
        driver_sealed: '封存',
        email: 'email',
        exclusive_service: '',
        final_location_time: '',
        firebase_token: '',
        gender: '性別',
        has_auto_generate_payment: '',
        id: 'id',
        identify: '身份字號',
        install_taxi_meter_date: '裝錶日',
        licence: '車牌',
        name: '名稱',
        note: '備註',
        password: '密碼',
        photo: '照片',
        plan: '方案',
        professional_driver_license_date: '職業駕照發照日',
        receive_car_license_date: '領牌日',
        reputation: '評分',
        resident_address: '地址',
        start_suspension_time: '開始停權時間',
        status: '狀態',
        suspension_until: '停權區間',
        taximeter_number: '跳表機碼',
        team_company_note: '車隊備註',
        team_manager_id: '管理人員id',
        type: '種類',
        verification_code: '驗證碼',
        verification_status: '驗證狀態',
        verification_time: '驗證時間',
      },
      originDriver: {},
      originServiceList: [],
    }
  },
  methods: {
    changeAuthorize() {
      this.startSuspenionTime = null
      this.endSuspenionTime = null
    },
    getSuspensionDate(value) {
      this.startSuspenionTime = value[0]
      this.endSuspenionTime = value[1]
      this.driver.info.authorize = '1' //停權
    },
    showSetSuspensionTime() {
      this.$refs.setSupspensionTime._openModal()
    },
    onEditDriverBtnClick() {
      this.edit_info = true
    },
    async onDeleteDriverBtnClick() {
      if (confirm('確定封存此司機資料？')) {
        BehaviorRecorder.record(
          '點擊',
          '司機資料',
          `封存司機-${this.driver.info.call_number}`,
        )
        const result = await driver.remove(this.id)
        if (result.success) {
          return this.$router.replace('/serviceMain/driverList')
        }
        alert(result.message)
      }
    },
    onEditPaymentBtnClick() {
      $('#paymentModal').modal('show')

      // this.show_payment_modal = true
    },
    onCancelEditPaymentBtnClick() {
      $('#paymentModal').modal('hide')
      // this.show_payment_modal = false
      // this.bills.length = 0
    },
    onDriverTypeChange(val) {
      this.$set(this, 'type', val)
      this.driver.service = []
      this.$refs.driverServiceList.setClearingServiceListActive()
    },
    /**
     * 判斷是否需要記錄異動
     * @param {Array} diffArrayKey - 欄位異動 key 陣列
     * @param {Array} diffName - 欄位異動名稱陣列
     * @param {Array} originServiceList - 原始服務 id 陣列
     * @param {Array} newServiceList - 當前服務 id 陣列
     * @returns {Boolean} 是否需要記錄異動
     */
    shouldRecordDriverUpdate(
      diffArrayKey,
      diffName,
      originServiceList,
      newServiceList,
    ) {
      // 權限是否唯一異動
      let onlyAuthorizeChanged =
        diffArrayKey.length === 1 && diffArrayKey[0] === 'authorize'
      // 服務項目是否異動
      let serviceChanged =
        JSON.stringify(originServiceList) !== JSON.stringify(newServiceList)
      // 有異動且不是只異動權限
      return (diffName.length > 0 || serviceChanged) && !onlyAuthorizeChanged
    },

    async onUpdateDriverBtnClick() {
      // 切換按鈕顯示
      this.edit_info = false
      try {
        // 使用者紀錄
        this.driverDataUpdatedRecord()
        this.driverPlanChangeRecord()
        this.driverTeamCompanyNoteChangeRecord()
        this.driverNoteChangeRecord()
        this.driverServiceChangeRecord()

        /* 若設定司機停權，須檢查是否有輸入停權的原因 */
        if (this.driver.info.authorize === '1' && !this.suspensionReason) {
          Notification({
            type: 'warning',
            message: '請輸入停權原因',
          })
          return
        }
        if (
          this.startSuspenionTime &&
          this.endSuspenionTime &&
          dayjs(this.startSuspenionTime).isAfter(this.endSuspenionTime)
        ) {
          Notification({
            type: 'warning',
            message: '結束時間須大於起始時間',
          })
          return
        }
        this.driver.service = this.$refs.driverServiceList.getServiceList()
        this.driver.info.service = this.driver.service
        if (this.driver.info.password === '********') {
          this.driver.info.password = undefined
        }
        this.driver.info.start_suspension_time = this.startSuspenionTime
        this.driver.info.suspension_until = this.endSuspenionTime
        //  判別修改哪一些參數
        let diff = checkObjectParameterDiffToValue(
          this.driverInfo,
          this.driver.info,
          this.driverHistory.info,
        )
        let diffName = []
        for (let i = 0; i < diff.diffArrayKey.length; i++) {
          diffName.push(
            diff.diffArrayValue[i] +
              `:${this.driver.info[diff.diffArrayKey[i]]}`,
          )
        }
        /* 若是授權或是審核中，須清除this.driver.info中的停權原因 */
        if (this.driver.info.authorize !== '1') {
          this.driver.info.suspension_reason = null
        }
        // 取得服務 id 陣列
        let originServiceList = this.originServiceList || []
        let newServiceList = this.driver.service || []
        // 判斷是否需要記錄異動
        const shouldRecord = this.shouldRecordDriverUpdate(
          diff.diffArrayKey,
          diffName,
          originServiceList,
          newServiceList,
        )
        const result = await driver.updateInfo(
          this.id,
          this.driver.info,
          shouldRecord,
        )
        if (!result.success) {
          Notification({
            message: result.message,
            type: 'warning',
          })
        } else {
          this.getDriverInfo()
          Notification({
            message: '更新司機資料成功',
            type: 'success',
          })
          // 權限有變動才要發權限變動紀錄
          if (diff.diffArrayKey.indexOf('authorize') == -1) return
          const payload = {
            call_number: this.driver.info.call_number,
            authorize: Number(this.driver.info.authorize),
            startSuspensionTime: this.startSuspenionTime,
            suspensionUntil: this.endSuspenionTime,
            suspension_reason: this.suspensionReason,
          }
          const result = await driver.updateSuspension(this.id, payload)
          switch (this.driver.info.authorize) {
            case '0': {
              // 正常權限
              diff.diffArrayKey.includes('authorize') &&
                BehaviorRecorder.record(
                  '點擊',
                  '司機資料',
                  `恢復正常權限 - ${this.driver.info.call_number}`,
                )
              break
            }

            case '1': {
              // 停權
              if (!result.success) throw '司機停權失敗'

              if (confirm('由於司機被停權，是否要強制司機回到離線狀態？')) {
                const {
                  startSuspenionTime,
                  endSuspenionTime,
                  suspensionReason,
                } = this
                const payload = {
                  title: '停權訊息',
                  driverId: this.id,
                  content: {
                    startTime: startSuspenionTime,
                    endTime: endSuspenionTime,
                    message: suspensionReason,
                  },
                }

                const msg =
                  startSuspenionTime && endSuspenionTime
                    ? `設定司機停權 - ${this.driver.info.call_number},
                         停權時間: ${startSuspenionTime}~${endSuspenionTime},
                         停權原因：${suspensionReason}`
                    : `設定司機停權 - ${this.driver.info.call_number}, 停權原因：${suspensionReason}`

                BehaviorRecorder.record('點擊', '司機資料', msg)

                this.suspensionReason = null

                API.post(`socket/attention`, payload)
                  .then(({ result }) =>
                    this.$msg(
                      result ? '傳送成功' : '傳送失敗,可能司機沒有開APP',
                    ),
                  )
                  .catch(console.error)
              }
              break
            }

            case '2': // 審核中
            default: {
              diff.diffArrayKey.includes('authorize') &&
                BehaviorRecorder.record(
                  '點擊',
                  '司機資料',
                  `審核中 - ${this.driver.info.call_number}`,
                )
            }
          }
        }
      } catch (e) {
        console.error(e)
        Notification({
          message: '更新司機資料失敗',
          type: 'error',
        })
      }
    },
    driverDataUpdatedRecord() {
      BehaviorRecorder.recordDiffData(this.originDriver, this.driver.info, {
        fieldMap: {
          call_number: '呼號',
          type: '種類',
          name: '姓名',
          gender: '性別',
          account: '帳號',
          contact1: '聯絡電話1',
          contact2: '聯絡電話2',
          email: '電子信箱',
          identify: '身份字號',
          birthday: '生日',
          resident_address: '戶籍地址',
          address: '通訊地址',
          business_license: '營業執照',
          car_brand: '製造車廠',
          licence: '車牌',
          available_seat: '可載座位數',
          receive_car_license_date: '領牌日',
          car_leave_factory_date: '出廠日',
          professional_driver_license_date: '職業駕照發照日',
          install_taxi_meter_date: '裝錶日',
        },
        extraMap: {
          type: {
            0: '一般計程車',
            1: '多元計程車',
          },
          gender: { 0: '男', 1: '女' },
        },
        title: '修改司機呼號',
      })
    },
    // 變更方案獨立通知
    driverPlanChangeRecord() {
      BehaviorRecorder.recordDiffData(this.originDriver, this.driver.info, {
        fieldMap: {
          plan: '方案',
        },
        extraMap: {
          plan: { 0: '車隊叫車/APP/Line', 1: 'APP/Line' },
        },
        title: '修改司機呼號',
      })
    },
    // 變更車隊備註
    driverTeamCompanyNoteChangeRecord() {
      BehaviorRecorder.recordDiffData(this.originDriver, this.driver.info, {
        fieldMap: {
          team_company_note: '車隊客服備註',
        },
        title: '修改司機呼號',
      })
    },
    // 填寫司機備註
    driverNoteChangeRecord() {
      BehaviorRecorder.recordDiffData(this.originDriver, this.driver.info, {
        fieldMap: {
          note: '司機備註',
        },
        title: '修改司機呼號',
      })
    },
    // 服務項目異動
    driverServiceChangeRecord() {
      var oldList = this.originServiceList || []
      var newList = this.$refs.driverServiceList.getServiceList() || []
      // 取得所有服務對照表
      var allService = this.$refs.driverServiceList.apiServiceList || []

      // 轉成名稱陣列
      function idToNameArr(arr) {
        return arr.map(function (id) {
          var found = allService.find(function (s) {
            return s.id === id
          })
          return found ? found.name : id
        })
      }
      BehaviorRecorder.recordDiffService(
        idToNameArr(oldList),
        idToNameArr(newList),
        {
          title: '修改司機呼號',
          call_number: this.originDriver.call_number,
        },
      )
    },
    onCarYearChange(val) {
      this.$refs.driverServiceList.onSetNewCar(val)
    },
    onServiceChange(type) {
      switch (type) {
        case 'suv':
          this.serviceHasThenSplice('barrier_free')
          break
        case 'barrier_free':
          this.serviceHasThenSplice('suv')
          break
        default:
      }
    },
    serviceHasThenSplice(type) {
      var service = this.driver.service
      if (service.includes(type)) {
        var index = service.indexOf(type)
        service.splice(index, 1)
      }
    },
    _renderInfo(data) {
      this.driver = data
      this.driver.info.password = '********'
      this.type = this.driver.info.type
      // 新增：每次渲染時都同步一份driver.info到originDriver
      this.originDriver = JSON.parse(JSON.stringify(this.driver.info))
    },
    async getDriverInfo() {
      let result = await driver.getDetail(this.id)
      /* console.log('司機資料', result) */
      if (result.success) {
        var data = result.message.data
        if (data.info.suspension_until) {
          this.endSuspenionTime = moment(data.info.suspension_until).format(
            'YYYY-MM-DD HH:mm:ss',
          )
          this.startSuspenionTime = moment(
            data.info.start_suspension_time,
          ).format('YYYY-MM-DD HH:mm:ss')
        }
        this.driverHistory = JSON.parse(JSON.stringify(data)) // 深拷貝
        this._renderInfo(data)
        this.$refs.driverServiceList.setfillOutServiceListCheckBox(data.service)
        // 記錄原始服務id陣列
        this.originServiceList = (data.service || []).map(function (item) {
          return item.serivceId
        })
      }
    },
    storedSave() {
      if (
        this.stored.fareOfPercent < 0 ||
        this.stored.platformFee < 0 ||
        this.stored.thresholdValue < 0
      ) {
        alert('車資百分比、平台費、儲值最低金額，需大於等於0')
        return
      } else if (
        this.stored.fareOfPercent == undefined ||
        this.stored.platformFee == undefined ||
        this.stored.thresholdValue == undefined
      ) {
        alert('請輸入儲值扣款設定')
        return
      }
      API.put(`store_value/formula/${this.$route.params.id}`, this.stored)
        .then((res) => {
          alert(res.message)
        })
        .catch((error) => {
          alert(error.data.error.message)
        })
    },
    storedFormula() {
      API.get(`store_value/formula/${this.$route.params.id}`)
        .then((res) => {
          this.stored = res.result
        })
        .catch((e) => {
          console.error(e)
        })
    },
    openStoredModal(page = 1, status) {
      this.status = status
      /* console.log(this.status) */
      if (this.status === '儲值紀錄') {
        API.get(
          `store_value/record/?per_page=25&current_page=${page}&kw=${this.driver.info.call_number}`,
        ).then((res) => {
          this.driverStored = res.result.data
          this.driverStoredPaging = res.result.paging
        })
      } else if (this.status === '扣款紀錄') {
        API.get(
          `store_value/deduct?per_page=25&current_page=${page}&kw=${this.driver.info.call_number}`,
        ).then((res) => {
          this.driverStored = res.result.data
          this.driverStoredPaging = res.result.paging
        })
      }
    },
    /**
     * 出廠日變動時，取年份呼叫服務自動勾選
     * @param {string} dateStr - 出廠日 YYYY-MM-DD
     */
    onCarLeaveFactoryDateChange(dateStr) {
      if (!dateStr) return
      this.$refs.driverServiceList.onSetNewCar(dateStr)
    },
  },
  computed: {
    permisionEditDriver() {
      return getAdminAuthorization('editDriver') === 2
    },
  },
  created() {
    this.getDriverInfo()
    this.storedFormula()
  },
}
</script>

<style scoped lang="scss">
/* h4 {
  min-width: 140px;
} */
.stored-title {
  display: inline-block;
  font-size: 18px;
  background-color: bisque;
  padding-top: 5px;
}

.stored {
  p,
  span {
    font-weight: bold;
  }

  button {
    margin: 10px 0;
  }

  a {
    margin: 0 30px;
    color: rgb(99, 186, 253);
  }
}

input.inputstyle {
  min-width: 240px;
}

.driverTitle {
  display: inline-block;
}

h4 {
  font-size: 18px;
  background-color: bisque;
  padding-top: 5px;
}

.margin10 {
  margin-bottom: 10px;
}

.fareImput {
  display: inline-block;
}

ul,
li {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.item-btn {
  float: right;
}

.suspension-time {
  color: red;
}

[data-tip] {
  position: relative;
}

[data-tip]:before {
  content: '';
  /* hides the tooltip when not hovered */
  display: none;
  content: '';
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #767575;
  position: absolute;
  top: 30px;
  left: 35px;
  z-index: 8;
  font-size: 0;
  line-height: 0;
  width: 0;
  height: 0;
}

[data-tip]:after {
  display: none;
  content: attr(data-tip);
  position: absolute;
  top: 35px;
  left: 21px;
  padding: 5px 8px;
  background: #767575;
  color: #fff;
  z-index: 9;
  font-size: 0.75em;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  white-space: nowrap;
  word-wrap: normal;
}

[data-tip]:hover:before,
[data-tip]:hover:after {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/driver/DriverDetail.vue